/**
 * API
 * !backend: Laravel
 */

import axios from "axios";

export default {

    get(request, success, danger) {
        // Construimos los headers dinámicamente
        const headers = {
            "Content-Type": "application/json",
        };

        // Solo agregamos Authorization si existe token
        if (request.token) {
            headers["Authorization"] = `Bearer ${request.token}`;
        }

        axios.get(request.url, { headers })
            .then(res => {
                success(res);
            })
            .catch(err => {
                if (err.response) {
                    window.Vue.httpCode.accordingStatus(err.response);
                    danger(err.response);
                } else {
                    console.error("Error-get en api.js", err);
                }
            });
    },


    post(request, success, danger) {
        // Construimos los headers dinámicamente
        const headers = {
            "Content-Type": "application/json",
        };

        // Solo agregamos Authorization si existe token
        if (request.token) {
            headers["Authorization"] = `Bearer ${request.token}`;
        }

        axios.post(request.url, request.params, { headers })
            .then(res => {
                success(res);
            })
            .catch(err => {
                // Manejo de error y fallback
                if (err.response) {
                    window.Vue.httpCode.accordingStatus(err.response);
                    danger(err.response);
                } else {
                    console.error("Error-post en api.js", err);
                }
            });
    },



    update(request, success, danger) {
        axios.patch(request.url, request.params)
            .then(
                res => {
                    success(res)
                },
                err => {
                    window.Vue.httpCode.accordingStatus(err.response)
                    danger(err.response)
                }
            ).catch((error) => {
                console.log(`Error-update en api.js ${error}`)
            });
    },

    destroy(request, success, danger) {
        axios.delete(request.url, { data: request.params ? request.params : {} })
            .then(
                res => {
                    success(res)
                },
                err => {
                    window.Vue.httpCode.accordingStatus(err.response)
                    danger(err.response)
                }
            ).catch((error) => {
                console.log(`Error-destroy en api.js ${error}`)
            });
    },

    postWithFile(request, success, danger) {
        let config = {
            headers: {
                'content-type': 'multipart/form-data'
            }
        }
        axios.post(request.url, request.formData, config)
            .then(
                res => {
                    success(res)
                },
                err => {
                    window.Vue.httpCode.accordingStatus(err.response)
                    danger(err.response)
                }
            ).catch((error) => {
                console.log(`Error-post-with-file en api.js ${error}`)
            });
    },

}